import { useEffect, useState } from 'react'
import { Button, Form, Spinner } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { categoryService } from '../../../services/categoryService'
import './AdminCategories.scss'

export default function AdminCategories() {
  const [categories, setCategories] = useState([])
  const [sendRequestsLoader, setSendRequestsLoader] = useState(false)

  const [newCategoryName, setNewCategoryName] = useState('')
  const [selectedParentId, setSelectedParentId] = useState('')

  useEffect(() => {
    fetchCategories()
  }, [])

  const fetchCategories = async () => {
    const response = await categoryService.getCategories()
    if (response.isOk) {
      setCategories(response.data)
    } else {
      toast.error('Greška pri dohvaćanju kategorija.')
    }
  }

  const handleAddCategory = async () => {
    if (!newCategoryName.trim()) {
      toast.warn('Naziv kategorije je obavezan.')
      return
    }

    setSendRequestsLoader(true)

    const payload = {
      name: newCategoryName.trim(),
      parent_category: selectedParentId || null,
    }

    const response = await categoryService.addCategory(payload)

    if (response.isOk) {
      toast.success('Kategorija dodana!')
      setNewCategoryName('')
      setSelectedParentId('')
      fetchCategories()
    } else {
      toast.error(response.message)
    }

    setSendRequestsLoader(false)
  }

  const renderCategories = categoriesList => {
    return (
      <ul>
        {categoriesList.map(cat => (
          <li key={cat.id}>
            {cat.name}
            {cat.children &&
              cat.children.length > 0 &&
              renderCategories(cat.children)}
          </li>
        ))}
      </ul>
    )
  }

  return (
    <div id="admin-categories">
      <h1 className="page-title">Kategorije</h1>

      <div className="category-form mt-4 mb-4">
        <Form>
          <Form.Group controlId="formCategoryName">
            <Form.Label>Naziv nove kategorije</Form.Label>
            <Form.Control
              type="text"
              placeholder="Unesi naziv"
              value={newCategoryName}
              onChange={e => setNewCategoryName(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="formParentCategory" className="mt-2">
            <Form.Label>Nadkategorija (opcionalno)</Form.Label>
            <Form.Select
              value={selectedParentId}
              onChange={e => setSelectedParentId(e.target.value)}>
              <option value="">Bez nadkategorije</option>
              {categories
                .filter(cat => cat.parent_category === null)
                .map(cat => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
            </Form.Select>
          </Form.Group>

          <Button
            className="mt-3 submit-button"
            onClick={handleAddCategory}
            disabled={sendRequestsLoader}>
            {sendRequestsLoader ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              'Dodaj kategoriju'
            )}
          </Button>
        </Form>
      </div>

      <div className="category-list">{renderCategories(categories)}</div>
    </div>
  )
}
